// extracted by mini-css-extract-plugin
export default {"form":"EmailSent_form__C0lcS","link1":"EmailSent_link1__yBmJv","link2":"EmailSent_link2__E+xFp"};